import {
  Box,
  Button,
  IconButton,
  InputBase,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { MdRemoveCircleOutline } from 'react-icons/md';
import isColorDark from '../../../../../../../utils/isColorDark';

export const RootStyled = styled(Box)(({ theme }) => ({
  padding: theme.spacing(10, 17),
  minWidth: '1280px',
}));

export const TitleBoxStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
});

export const TitleStyled = styled(Typography)({
  paddingTop: '3rem',
});

export const CloseIconStyled = styled(IconButton)({
  padding: '0.5rem',
  color: '#000',
  alignItems: 'flex-start',
  height: '40px',
});

export const NameStyled = styled(Typography)({
  padding: '1rem 0',
});

export const HeaderTypographyStyled = styled(Typography)({
  fontSize: '1rem',
  fontWeight: 500,
});

export const ButtonBoxStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '0.5rem',
});

export const BtnStyled = styled(Button)(({ theme }) => ({
  width: 250,
  height: 54,
  margin: '1rem 0',
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.global.white,
  fontWeight: 'bold',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
    filter: 'brightness(92%)',
  },
}));

export const OutlinedButtonStyled = styled(Button)({
  width: 250,
  height: 54,
  margin: '1rem 0',
  fontWeight: 'bold',
  textTransform: 'none',
  border: '1px solid',
});

export const TableContainerStyled = styled(TableContainer)({
  maxHeight: 680,
});

export const TableCellHeaderStickyStyled = styled(TableCell)(({ theme }) => ({
  height: '62px',
  color: isColorDark(theme.palette.primary.main)
    ? theme.palette.global.white
    : theme.palette.global.black,
  fontWeight: 500,
  fontSize: '14px',
  textAlign: 'center',
  backgroundColor: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
    color: isColorDark(theme.palette.primary.main)
      ? theme.palette.global.white
      : theme.palette.global.black,
  },
  padding: '16px 4px',
  minWidth: '170px',
  left: '0px',
  position: 'sticky',
  zIndex: 99,
  opacity: 1,
}));

export const TableCellHeaderFixedTotalStyled = styled(TableCell)(
  ({ theme }) => ({
    position: 'sticky',
    zIndex: 99,
    left: '200px',
    height: '48px',
    color: isColorDark(theme.palette.primary.main)
      ? theme.palette.global.white
      : theme.palette.global.black,
    fontWeight: 500,
    fontSize: '12px',
    backgroundColor: alpha(theme.palette.primary.main, 1),
    textAlign: 'center',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: isColorDark(theme.palette.primary.main)
        ? theme.palette.global.white
        : theme.palette.global.black,
    },
    padding: '12px 6px',
    minWidth: '120px',
  })
);

export const TableCellHeaderStyled = styled(TableCell)(({ theme }) => ({
  height: '62px',
  color: isColorDark(theme.palette.primary.main)
    ? theme.palette.global.white
    : theme.palette.global.black,
  fontWeight: 500,
  fontSize: '14px',
  textAlign: 'center',
  backgroundColor: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
    color: isColorDark(theme.palette.primary.main)
      ? theme.palette.global.white
      : theme.palette.global.black,
  },
  padding: '16px 4px',
  minWidth: '170px',
  left: '0px',
}));

export const RemoveIconStyled = styled(MdRemoveCircleOutline)({
  color: 'red',
  fontSize: '18px',
  marginTop: '4px',
  borderRadius: '50%',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: 'red',
    color: '#ffffff',
  },
});

export const AddPeriodCellStyled = styled(TableCell)(({ theme }) => ({
  height: '62px',
  fontSize: '18px',
  backgroundColor: theme.palette.primary.main,
  textAlign: 'center',
  minWidth: '3.5em',
  border: '1px solid #e0e0e0',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
    color: isColorDark(theme.palette.primary.main)
      ? theme.palette.global.white
      : theme.palette.global.black,
    cursor: 'pointer',
  },
  padding: '16px 4px',
  left: '0px',
}));

export const TableRowStyled = styled(TableRow)(({ theme }) => ({
  height: '62px',
  '&:hover': {
    backgroundColor: alpha(theme.palette.global.gray, 0.1),
  },
  '&.primary-item': {
    backgroundColor: alpha(theme.palette.primary.main, 0.7),
  },
  '&.secondary-item': {
    backgroundColor: alpha(theme.palette.primary.main, 0.4),
  },
  '&.tertiary-item': {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
  },
}));

export const TableCellHeaderFixedStyled = styled(TableCell)(({ theme }) => ({
  position: 'sticky',
  zIndex: 99,
  left: '0px',
  height: '48px',
  color: isColorDark(theme.palette.primary.main)
    ? theme.palette.global.white
    : theme.palette.global.black,
  fontWeight: 500,
  fontSize: '12px',
  backgroundColor: alpha(theme.palette.primary.main, 1),
  textAlign: 'center',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
    color: isColorDark(theme.palette.primary.main)
      ? theme.palette.global.white
      : theme.palette.global.black,
  },
  padding: '12px 6px',
  minWidth: '120px',
}));

export const EmptyTableCellStyled = styled(TableCell)(({ theme }) => ({
  height: '62px',
  fontSize: '18px',
  textAlign: 'center',
  width: '3.5em',
  border: '1px solid #e0e0e0',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
    color: isColorDark(theme.palette.primary.main)
      ? theme.palette.global.white
      : theme.palette.global.black,
  },
  padding: '16px 4px',
  left: '0px',
}));

export const CellInputStyled = styled(InputBase)({
  outline: 0,
  border: 'none',
  width: '100%',
  padding: '4px 20px',
  fontFamily: 'montserrat',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  fontWeight: 600,
  '& .MuiInputBase-input': {
    width: '40px',
    textAlign: 'center',
  },
});

export const ItemNumStyled = styled('span')({
  fontWeight: 600,
  fontSize: '1rem',
  display: 'inline-block',
  width: '40px',
});

export const TableCellStyled = styled(TableCell)(({ theme }) => ({
  fontSize: '12px',
  position: 'sticky',
  zIndex: 99,
  left: '0px',
  minWidth: '200px',
  border: 'none',
  backgroundColor: theme.palette.primary.main,
  borderBottom: '1px solid #e0e0e0',
  '&:hover': {
    backgroundColor: alpha(theme.palette.global.gray, 1),
  },
}));

export const TableCellFatherStyled = styled(TableCell)(({ theme }) => ({
  position: 'sticky',
  zIndex: 99,
  left: '200px',
  border: '1px solid #e0e0e0',
  minWidth: '64px',
  textAlign: 'center',
  fontWeight: 600,
  fontSize: '12px',
  backgroundColor: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: alpha(theme.palette.global.gray, 1),
  },
  '&.MuiTableCell-root': {
    padding: '8px 12px',
  },
}));

export const FatherSTableCellStyled = styled(TableCell)(({ theme }) => ({
  border: '1px solid #e0e0e0',
  minWidth: '64px',
  textAlign: 'center',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: alpha(theme.palette.global.gray, 0.1),
  },
  '&.MuiTableCell-root': {
    padding: '10px 16px',
  },
}));
